<template>
  <b-container 
    class="mobile-header p-2 fixed-top d-lg-none">
    <b-row class="align-items-center justify-content-between m-0">
      <b-col
        cols="1"
        class="p-0">
        <router-link
          to="/members">
          <span class="mobile-header__icon mobile-header__icon--list material-icons">
            format_list_bulleted
          </span>
        </router-link>
      </b-col>
      <template v-if="hasSelectedMember">
        <b-col class="px-0 d-flex justify-content-center">
          <b-button
            v-if="showProfileButton"
            :to="isProfilePage ? `/members/${selectedMember.id}` : `/members/${selectedMember.id}/profile`"
            class="profile-button p-1 text-decoration-none"
            size="sm"
            :variant="isProfilePage ? 'primary' : 'outline-primary'">
            Profile
          </b-button>
        </b-col>
        <b-col
          cols="5"
          class="px-0">
          <div class="mobile-header__member d-flex align-items-center justify-content-center">
            <img
              v-if="selectedMember.avatar"
              :src="selectedMember.avatar"
              class="img-fluid mobile-header__img rounded-circle">
            <b-avatar
              v-else
              class="mr-2"
              size="22px"
              :text="selectedMember.name|initial" />
            <h1 class="mobile-header__name ml-2 text-truncate">
              {{ selectedMember.name }}
            </h1>
          </div>
        </b-col>
        <b-col class="text-center px-0">
          <slot />
        </b-col>
      </template>
      <b-col
        cols="1"
        class="text-right p-0" />
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    selectedMember: {
      type: Object,
      default: null
    },
    showCompass: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isManager', 'isParentMember']),
    hasSelectedMember() {
      return this.selectedMember !== null
    },
    isProfilePage() {
      return this.$route.path.split('/')[3] === 'profile'
    },
    isMyProfile() {
      return this.selectedMember.id === this.user.id
    },
    showProfileButton() {
      // 保護者はProfileを閲覧できない
      if (this.isParentMember) {
        return false
      }
      // 管理者は全てのProfileを閲覧できる
      if (this.isManager) {
        return true
      }
      // 一般ユーザは本人のProfileを閲覧できる
      return this.selectedMember.id === this.user.id
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header {
  max-width: 500px;
  margin: auto;

  background-color: $white;
  border-bottom: solid 1px $grey11;

  .profile-button {
    box-shadow: 1px 2px 6px $grey05;
  }

  @media screen and (min-width:768px) {
    width: 100%;
    max-width: 100%;
  }
  &__icon{
    &--list{
      color: $grey12;
    }
  }
  &__img{
    width: 22px;
    height: 22px;
    object-fit: cover; 
  }
  &__name{
    font-size: $fs-nm;
    font-weight: bold;
  }

  ::v-deep .category-list_wrapper {
    right: -29px;
  }
}
</style>